/**
 * Dental Procedure Consent Form — Stage 2.
 */
import { Text } from '@react-pdf/renderer'

import { SNOOTS_BG } from '@snootsvet/shared'

import {
  ANAESTHESIA_RISK_CLAUSE,
  DENTAL_S2_COST_CLAUSE,
  DENTAL_S2_FINDINGS_CLAUSE,
  DENTAL_S2_MORE_EXTRACTIONS_CLAUSE,
  DISCHARGE_TIME_CLAUSE,
  EMERGENCY_AUTH_CLAUSE,
  EXTRACTION_RISK_CLAUSE,
  IV_FLUIDS_CLAUSE,
} from '@/frontend/features/printing/documents/consent/clauses'
import { buildPreOpConsentForm } from '@/frontend/features/printing/documents/consent/consent-template.form'

const consentText = (name: string) =>
  `I am the owner or authorised agent for the owner of ${name}. I give my consent for Snoots to perform a general anaesthetic & dental extractions.`

export const dentalConsentStage2 = buildPreOpConsentForm({
  id: 'dental-consent-stage2',
  label: 'Dental Consent — Stage 2',
  title: 'DENTAL PROCEDURE CONSENT FORM – STAGE 2',
  // Dental procedures are carried out at the Bounds Green clinic.
  clinic: SNOOTS_BG,
  renderConsentPreview: ({ patientName }) => <p>{consentText(patientName)}</p>,
  renderConsentPrint: ({ patientName }) => (
    <Text style={{ fontSize: 10 }}>{consentText(patientName)}</Text>
  ),
  clauses: [
    DENTAL_S2_FINDINGS_CLAUSE,
    DENTAL_S2_COST_CLAUSE,
    DENTAL_S2_MORE_EXTRACTIONS_CLAUSE,
    ANAESTHESIA_RISK_CLAUSE,
    EXTRACTION_RISK_CLAUSE,
    EMERGENCY_AUTH_CLAUSE,
    IV_FLUIDS_CLAUSE,
    DISCHARGE_TIME_CLAUSE,
  ],
})
